import { createSelector } from "reselect";
import _ from "lodash";

export const selectTimesheets = ({ TimesheetManagerPage_reducer }) => {
    return TimesheetManagerPage_reducer.reportTypes;
};
export const getRequesting  = ({ TimesheetManagerPage_reducer }) => {
    return TimesheetManagerPage_reducer.requesting;
};
export const selectUsers = ({ TimesheetManagerPage_reducer }) => {
    return TimesheetManagerPage_reducer.users;
};
export const selectedUser = ({ TimesheetManagerPage_reducer }) => {
    return TimesheetManagerPage_reducer.selectedUser;
};
export const selectYear = ({ TimesheetManagerPage_reducer }) => {
    return TimesheetManagerPage_reducer.selectedYear;
};
export const selectWeek = ({ TimesheetManagerPage_reducer }) => {
    return TimesheetManagerPage_reducer.selectedWeek;
};
export const selectData = createSelector(
    [selectUsers, selectTimesheets, selectYear, selectWeek, selectedUser],
    (
        users = false,
        timesheets = false,
        year = false,
        week = false,
        selectedUser = "all_users"
    ) => {
        if (users && timesheets && year && week) {
            return Object.keys(timesheets).map(uid => {
                let fname = _.get(users[uid], "profile.first_name") || "N/A";
                let lname = _.get(users[uid], "profile.last_name") || "N/A";

                let time =
                    _.get(
                        timesheets[uid],
                        `reports.timesheets.${year}.${week}`
                    ) || {};
                if (selectedUser !== "all_users" && selectedUser === uid)
                    return { uid, name: `${fname} ${lname}`, timesheets: time };
                else if (selectedUser === "all_users")
                    return { uid, name: `${fname} ${lname}`, timesheets: time };
                else return { uid, name: `${fname} ${lname}`, timesheets: {} };
            });
        } else return false;
    }
);
